import * as React from 'react';
import * as ReactDOM from 'react-dom';

import styled from '@emotion/styled';

import { zIndexValues } from '~/styles/constants';

const Container = styled('div')<{ backgroundColor?: string; zIndex?: number }>`
  position: fixed;
  z-index: ${({ zIndex }) => zIndex || zIndexValues.modal};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ backgroundColor }) => backgroundColor || 'rgba(128, 128, 128, 0.8)'};
  text-align: center;
  overflow: auto;
`;

const modalRoot = document.getElementById('modalRoot');
const el = Symbol();

export const ZIndexContext = React.createContext<number | undefined>(undefined);

class OuterContainer extends React.PureComponent<{ backgroundColor?: string; zIndex?: number }> {
  [el]: HTMLElement;

  constructor(props) {
    super(props);
    this[el] = document.createElement('div');
  }

  componentDidMount() {
    document.documentElement!.style.overflow = 'hidden';
    if (modalRoot) modalRoot.appendChild(this[el]);
  }

  componentWillUnmount() {
    document.documentElement!.style.overflow = '';
    if (modalRoot) modalRoot.removeChild(this[el]);
  }

  render() {
    return ReactDOM.createPortal(
      <Container backgroundColor={this.props.backgroundColor} zIndex={this.props.zIndex}>
        <ZIndexContext.Provider value={zIndexValues.modal}>
          {this.props.children}
        </ZIndexContext.Provider>
      </Container>,
      this[el],
    );
  }
}

export default OuterContainer;
